"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadersExpansion = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
class LeadersExpansion {
    static getBonusWildTags(player) {
        const xavier = player.playedCards.find((card) => card.name === CardName_1.CardName.XAVIER);
        if (xavier !== undefined && xavier.opgActionIsActive === true) {
            return 2;
        }
        return 0;
    }
    static getBonusInfluence(player) {
        const darwin = player.playedCards.find((card) => card.name === CardName_1.CardName.DARWIN);
        if (darwin !== undefined && darwin.opgActionIsActive === true) {
            return 2;
        }
        return 0;
    }
    static leaderActionIsUsable(player) {
        if (player.game.gameOptions.leadersExpansion === false)
            return false;
        const leaders = player.playedCards.filter((card) => card.cardType === CardType_1.CardType.LEADER);
        if (leaders.length === 0)
            return false;
        if (leaders.every((leader) => leader.canAct === undefined))
            return false;
        return leaders.some((leader) => leader.canAct !== undefined && leader.canAct(player));
    }
}
exports.LeadersExpansion = LeadersExpansion;
//# sourceMappingURL=LeadersExpansion.js.map